"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterForIDsWithAssignment = void 0;
function filterForIDsWithAssignment(assignmentData, ids) {
    return ids.filter((id) => Object.keys(assignmentData.data).filter((_id) => _id === id));
}
exports.filterForIDsWithAssignment = filterForIDsWithAssignment;
